import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ButtonLoading } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useConfirmation } from "go-form/components/ModalConfirm";
import { InvitationApi } from "../../../../../services/Api/Organization/organizationTypes";
import { api } from "../../../../../services/Security/api";
import { useAuth } from "../../../../../services/Security/auth";

interface Props {
	invitation: InvitationApi;
	onAccept: () => void;
}

const OrganizationAcceptInvitation: FC<Props> = (props: Props) => {
	const [loading, setLoading] = useState(false);
	const auth = useAuth();
	const history = useHistory();
	const { addFlash, addSuccessFlash } = useFlash();
	const confirmation = useConfirmation();
	const { t } = useTranslation();

	const handleAcceptInvitation = () => {
		setLoading(true);
		api.user()
			.acceptMeInvitation(props.invitation.id)
			.then((res) => {
				// auth.checkLogin();
				props.onAccept();
				addSuccessFlash(t("common.flash.completed", { ns: "lib" }));
				setLoading(false);
			})
			.catch((err) => {
				handleError.alert(err, addFlash);
				setLoading(false);
			});
	};

	const handleRejectInvitation = async () => {
		try {
			await confirmation({
				title: t("lib:go_form.modal_confirm.title"),
			});
			setLoading(true);
			await api.user().rejectMeInvitation(props.invitation.id);
			history.push("/");
			addSuccessFlash(t("common.flash.completed", { ns: "lib" }));
		} catch (err) {
			handleError.alert(err, addFlash);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="container-fluid mt-2">
			<div className="col-6">
				<h5>
					{t("modules.organization.field.accept_invitation.title", {
						name: props.invitation.organization.name,
					})}
				</h5>
				<ButtonLoading
					size="sm"
					className="me-1"
					loading={loading}
					variant="primary"
					type="button"
					onClick={() => handleAcceptInvitation()}
				>
					{t("common.action.accept", { ns: "lib" })}
				</ButtonLoading>
				<ButtonLoading
					size="sm"
					style={{ color: "red" }}
					loading={loading}
					variant="light"
					type="button"
					onClick={() => handleRejectInvitation()}
				>
					{t("common.action.reject", { ns: "lib" })}
				</ButtonLoading>
			</div>
		</div>
	);
};

export default OrganizationAcceptInvitation;
